// React
import { useState } from "react";
// Context
import { useAuth } from "../context/AuthContext";
// Styles
import "../styles/AdminDashboard.css";
// Components
import NavBar from "../components/dashboard/NavBar";
import PageTitle from "../components/dashboard/PageTitle";
import DashboardTabs from "../components/dashboard/DashboardTabs";
import UsersTab from "../components/dashboard/UsersTab";
import SoilDatasetsTab from "../components/dashboard/SoilDatasetsTab";
// Custom Hooks
import useFetchUsers from "../hooks/useFetchUsers";

// ─────────────────────────────────────────────────────────────────
function AdminDashboardPage() {
  const { profile } = useAuth();

  // TanStack Query hook to fetch users from Supabase, with caching and refetch capabilities
  const { users, isLoadingUsers, usersError, refetch } = useFetchUsers();

  // Which tab is active: "users" | "datasets" | "settings"
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="adminDash">
      {/* ── TOP NAV ────────────────────────────────────────────── */}
      <NavBar fullName={profile?.full_name || "Administrator"} />

      {/* ── MAIN CONTENT ───────────────────────────────────────── */}
      <main className="adminDash__main">
        <div className="adminDash__inner">
          {/* PAGE TITLE */}
          <PageTitle />

          {/* TABS */}
          <DashboardTabs activeTab={activeTab} setActiveTab={setActiveTab} />

          {/* ── TAB: USERS ───────────────────────────────────────── */}
          {activeTab === "users" && (
            <UsersTab error={usersError} isLoadingUsers={isLoadingUsers} users={users} refetch={refetch} />
          )}

          {/* ── TAB: DATASETS ────────────────────────────────────── */}
          {activeTab === "datasets" && <SoilDatasetsTab />}
        </div>
      </main>
    </div>
  );
}

export default AdminDashboardPage;
